import { Controller } from "@hotwired/stimulus";
import "tom-select/dist/css/tom-select.default.css";
import TomSelect from "tom-select";
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.dataLoaded = false;
    }
    get select() {
        if (this.element instanceof HTMLSelectElement) {
            return this.element;
        }
        if (this.hasSelectTarget && this.selectTarget instanceof HTMLSelectElement) {
            return this.selectTarget;
        }
        throw new Error("No compatible element found");
    }
    connect() {
        this.tomSelect = new TomSelect(this.select, {
            allowEmptyOption: true,
            create: true,
            labelField: "name",
            valueField: "id",
            searchField: ["name"],
            maxItems: 1,
            preload: true,
            load: this.loadCallback.bind(this),
            render: {
                option_create: (data, escape) => {
                    return `<div class="create">Utilizar <strong>${escape(data.input)}</strong>&hellip;</div>`;
                },
                no_results: () => {
                    return '<div class="no-results">No se encontraron resultados</div>';
                },
            },
        });
    }
    reloadData() {
        this.dataLoaded = false;
        this.tomSelect.clear();
        this.tomSelect.clearOptions();
        this.tomSelect.settings.load = this.loadCallback.bind(this);
        this.tomSelect.load("");
    }
    loadCallback(query, callback) {
        if (this.dataLoaded) {
            callback([], []);
            return;
        }
        window
            .fetch(this.remoteUrlValue)
            .then((res) => res.json())
            .then((data) => {
            callback(data.data, []);
            this.tomSelect.settings.load = null;
            this.dataLoaded = true;
        })
            .catch((error) => callback([], []));
    }
}
default_1.targets = ["select"];
default_1.values = {
    remoteUrl: String,
};
//# sourceMappingURL=select_controller.js.map